import { cn } from "@/lib/utils"

interface SelectableItemProps {
  icon: any
  label: string
  description?: string
  onClick?: () => void
  rightIcon?: React.ReactNode
  className?: string
}

function SelectableItem(props: SelectableItemProps) {
  return (
    <button
      className={cn(
        `
          group flex w-full items-center gap-5 rounded-xl p-4 py-3 text-left

          hover:bg-card-hover
        `,
        props.className,
      )}
      onClick={props.onClick}
    >
      <i className="shrink-0 fc">{props.icon}</i>
      <div className="flex flex-1 flex-col">
        <span className="font-semibold">{props.label}</span>
        {props.description && <span className="text-[13px] text-secondary">{props.description}</span>}
      </div>
      {!!props.rightIcon && (
        <i
          className={`
            shrink-0 text-secondary fc

            group-hover:text-fg
          `}
        >
          {props.rightIcon}
          {/* <IconHugeiconsArrowRight02 /> */}
        </i>
      )}
    </button>
  )
}

export default SelectableItem
